import apiCall from "./apiCall";

const ajaxUser = {
  async login(username, password) {
    const data = {
      username: username,
      password: password
    };
    return await apiCall("central/watchman/login", data);
  },
  async fetchUserProfiles() {
    let response = await apiCall("central/tenant/session_org", []);
    return response;
  },

  async switchProfiles(profile_id) {
    const data = {
      rental_id: profile_id
    }
    let response = await apiCall("central/tenant/switch_org", data);
    return response;
  },
  
  async exitProfile() {
    return await apiCall("central/tenant/exit_profile", []);
  },

  async signup(data) {
    return await apiCall("central/watchman/signup", data);
  },

  async resetPassword(password) {
    const data = {
      password: password,
    };
    return await apiCall("central/watchman/new_password", data);
  },


  async createProfile(data) {
    return await apiCall("central/rental/new_profile", data);
  },

  async sendEmailVerification(email) {
    const data = {
      email_address: email
    }
    return await apiCall("central/emailauth/send_verification_email", data);
  },
   async fetchMyProfile() {
    return await apiCall('platform/webclient/my_profile', []);
  },

   async fetchCentralProfile() {
    return await apiCall('central/watchman/info', []);
  },
  async trackOnline() {
    return await apiCall('platform/webclient/track_heartbeat', {});
  },
  async forgotPassword(email) {
    const data = {
      email_address: email
    }
    return await apiCall("central/watchman/forgot_password", data);
  },
  async verifyPasswordReset(data){
    return await apiCall("central/watchman/verify_password_reset", data);
  }

};

export default ajaxUser;